import React, { useEffect, useState } from "react";
import { Avatar, type AvatarProps, type SxProps, type Theme } from "@mui/material";

export type EntityTableAvatarProps = {
  src?: string | null;
  name?: string | null;
  size?: number;
  sx?: SxProps<Theme>;
} & Omit<AvatarProps, "src" | "children" | "variant">;

/**
 * Table cell avatar: shows photo when available, otherwise a neutral circle with an initial.
 */
export const EntityTableAvatar: React.FC<EntityTableAvatarProps> = ({
  src,
  name,
  size = 30,
  sx,
  imgProps,
  ...avatarProps
}) => {
  const trimmed = src?.trim() ?? "";
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [trimmed]);

  const showSrc = Boolean(trimmed) && !imgFailed;
  const initial = (name?.trim()?.charAt(0) || "?").toUpperCase();

  return (
    <Avatar
      {...avatarProps}
      src={showSrc ? trimmed : undefined}
      alt=""
      variant="circular"
      imgProps={{
        ...imgProps,
        onError: (e) => {
          setImgFailed(true);
          imgProps?.onError?.(e);
        },
      }}
      sx={{
        width: size,
        height: size,
        fontSize: Math.max(11, size * 0.35),
        bgcolor: "#e0e0e0",
        color: "#5f6368",
        flexShrink: 0,
        ...sx,
      }}
    >
      {initial}
    </Avatar>
  );
};
